// `@host/tenant` cho CNV Connect.
//
// VÌ SAO CÓ FILE NÀY: trước đây alias `@host/tenant` trỏ THẲNG vào stub của cnv-ui
// (`cnv-ui/src/config/tenant.js`), mà stub đó khai `app_name: 'CNV Work'` — tên thương hiệu
// của CỤM KHÁC. 17 chỗ trong cnv-ui đọc `tenant.app_name`, nên cụm Connect thừa hưởng luôn
// tên đó ở những nơi người dùng ĐỌC ĐƯỢC:
//   • Hệ thống → Cài đặt chung: gợi ý (placeholder) của «Tên hệ thống» ra "CNV Work"
//   • Cài đặt chung → SMTP: `smtp_from_name` mặc định = "CNV Work"
//   • Tiện ích → Email Template: tên công ty ở header/footer mẫu, và nút "Tải app CNV Work"
// Sửa ở cnv-ui thì kéo theo cụm Work (đúng thương hiệu của họ) — nên override Ở ĐÂY, đúng
// luật cách ly thương hiệu (xem docs + memory reference_connect_brand_isolation).
//
// Giữ nguyên phần còn lại của stub: `modules`, `private_modules`, `features`, `cnv_only`…
// là hợp đồng dùng chung với các page port từ Core, không phải chuyện thương hiệu.

import base from '@kernel/tenant';

const tenant = {
  ...base,
  id: 'cnv-connect',
  app_name: 'Site Connect',
  app_short: 'SC',
  branding: {
    ...base.branding,
    login_subtitle: 'PROJECTS · SCHEDULING · TIME TRACKING',
    // Tâm bản đồ khi chưa có điểm nào (form vị trí dự án, bản đồ check-in, bản đồ dự án) — cnv-ui
    // lib/hostBrand MAP_DEFAULT_CENTER. Không khai thì kernel mặc định giữa Hà Nội (Work, Core).
    map_default_center: [43.6532, -79.3832],
    // Stub kernel khai '/logo.png' (logo của hệ khác). Hiện không màn nào của Connect đọc khoá này — đặt đúng
    // để chỗ nào sau này đọc cũng ra logo Site Connect.
    logo: '/siteconnect.png',
    // Dấu nhận diện SẢN PHẨM ở những chỗ kernel từng ghi cứng «CNV Work» / `/cnvwork.png` (cnv-ui
    // `lib/hostBrand.js`): màn chờ đầu tiên của Chat — người vừa đăng ký bị đẩy thẳng vào /chat nên đó là
    // màn ĐẦU TIÊN họ thấy (góp ý khách 10/10/2026: logo CNV Work) —, lời nhắc «mở app … trên điện thoại»
    // ở thẻ chấm công, ví dụ tên ấn phẩm ở Kho in ấn. Khoá riêng, KHÔNG dùng `app_name`/`logo`: Core khai
    // `app_name: 'CNV Connect'` mà app nhân viên của họ vẫn là CNV Work ⇒ kernel không đọc hai khoá đó.
    product_name: 'Site Connect',
    product_logo: '/siteconnect.png',
  },
  // Ô thông báo hệ thống (broadcast của máy chủ chat) ghim đầu Chat — cnv-ui `lib/teamChatBroadcast.js`.
  // Góp ý khách 10/10/2026: vừa đăng ký xong thấy ô «CNVWork» với tin «CNV Work nâng cấp phiên bản 1.5.3»
  // (tin của hệ khác, gửi 30/08 bằng đường «gửi tất cả» cũ — không mang danh sách hệ nhận).
  //   • broadcast_name   — tên ô ở thanh bên / tìm kiếm / màn đọc (máy chủ chat luôn trả «CNVWork»).
  //   • broadcast_strict — chỉ hiện tin NHẮM ĐÍCH DANH Site Connect (CNVCONNECT_SAAS) và tạo SAU khi tài
  //     khoản chat của người xem ra đời; lọc xong không còn tin nào ⇒ ẩn HẲN ô. Console Site Connect chỉ gửi
  //     theo hệ (announcementService) nên tin của chính mình luôn qua lọt.
  // Core + Work không khai ⇒ ô vẫn tên «CNVWork», feed giữ nguyên như máy chủ trả.
  team_chat: {
    broadcast_name: 'Site Connect',
    broadcast_strict: true,
  },
  // Stub kernel khai `emails.from_name: 'CNV Work'` — tên người gửi mặc định của mẫu email dựng ở hub (Cài đặt ›
  // Email templates, mẫu FE dự phòng). Từ 12/10/2026 các tệp mẫu email của kernel đọc @host/tenant (trước import
  // tương đối thẳng vào stub ⇒ xem trước ghi «at CNV Work»). Giữ reply_to/support rỗng: hòm thư là của KHÁCH.
  emails: {
    ...base.emails,
    from_name: 'Site Connect',
  },
  modules: {
    ...base.modules,
    // Connect CÓ trang Cài đặt chấm công phân tầng (/attendance/policies). Cờ này nói cho
    // trang Ca làm việc dùng chung biết mà ẨN hai ô ảnh/GPS của nó đi: quy tắc "chấm thế nào
    // được tính" đi theo NGƯỜI và NƠI LÀM, không đi theo GIỜ TRONG NGÀY — chuẩn chung của
    // Deputy / Connecteam / UKG / Workday. Để cả hai chỗ thì thành hai đường làm một việc,
    // mà lớp chính sách luôn đè lên nên người khai sửa ở màn ca lại tưởng không tác dụng.
    //
    // ⚠️ Core và Work SaaS KHÔNG đặt cờ này (chưa có trang chính sách) ⇒ màn ca của họ giữ
    // nguyên. Đo trước khi bật ở Connect: 4/4 ca trên prod có `attendance_rules = NULL`, tức
    // chưa khách nào từng khai hai ô đó ⇒ không ai phải khai lại.
    attendance_policies: true,
    // Hỗ trợ (ticket/help desk) TẮT 27/08/2026 — sếp Phú: "hiện tại chưa cần tính năng này".
    // Menu + route đã chặn ở AppLayout/App.jsx, nhưng cụm Hỗ trợ còn HAI lối tạo phiếu nằm
    // trong gói dùng chung, không đi qua menu: phím tắt chụp màn hình (Ctrl/Cmd+Shift+2 →
    // "Tạo ticket") và menu tin nhắn / menu "+" của Chat nội bộ. Cả hai đọc đúng khoá này.
    // Core + Work SaaS KHÔNG khai ⇒ undefined ⇒ `!== false` ⇒ của họ giữ nguyên.
    support: false,
    // Nhập nhà cung cấp từ tệp: Connect chưa có 4 đường /suppliers/import/* (bấm là 404 — rà 12/10/2026) ⇒ kernel
    // SupplierListPage ẩn nút. Port tính năng nhập từ Work thì xoá dòng này.
    supplier_import: false,
    // ── Các cụm CHỈ CNV bán — TẮT HẲN 12/10/2026 (sếp Phú: Site Connect không bán, chữ «CNV Work» / tiếng Việt
    // của chúng không được tới tay người dùng Site Connect). Menu + route đã chặn từ 13/08 (AppLayout/App.jsx);
    // các khoá dưới đây gác nốt phần MÃ DÙNG CHUNG không đi qua menu — kernel đọc qua `@cnv/ui/lib/hostModules`
    // (luật `!== false`: Core + Work SaaS không khai hoặc khai true ⇒ của họ y nguyên):
    //   crm         — badge CRM/fulfillment (useBadgeCounts, ~92 lượt /crm/* mỗi đường trong 14 ngày), 9 drawer CRM +
    //                 đơn triển khai, card CRM trong Chat, tab «Deal» của «Việc» trong phòng, nút liên kết CRM ở việc,
    //                 ô chọn bản ghi CRM của mẫu phê duyệt (builder không cho thêm; form gửi đơn ẩn), chế độ «Gặp
    //                 khách hàng» của ô Bằng chứng ra ngoài, EntityRefDisplay không hỏi /crm/*; PermissionsPage (bảng
    //                 dự phòng) ẩn nhóm quyền CRM.
    //   recruitment — card ứng viên / lịch phỏng vấn trong Chat.
    //   inbox       — card hội thoại Hộp thư trong Chat.
    //   marketing / fulfillment / etelecom — khai cho đủ (kernel chưa đọc; fulfillment/etelecom stub vốn đã false).
    //                 «Kho in ấn» (Tiện ích) gọi `/marketing/print-items` KHÔNG đọc cờ marketing ⇒ vẫn chạy.
    // Máy chủ cũng chặn các cụm này (api/src/middleware/cnvOnlyModulesOff.js) — hai lớp độc lập.
    crm: false,
    recruitment: false,
    inbox: false,
    marketing: false,
    fulfillment: false,
    etelecom: false,
  },
  features: {
    ...base.features,
    // Lương — stub kernel đã khai false (Work tắt 07/10); khai lại ở đây cho rõ Site Connect KHÔNG bán Lương: lối tắt
    // «Bảng lương cá nhân» ở Cài đặt cá nhân (kernel AccountSection) ẩn. `compensation_payslips` không khai ⇒ cũng ẩn.
    payroll: false,
  },
};

export default tenant;
